import { TranslationDTO } from '../dtos/translation'
import { Id } from 'types/definitions'
import { DateZero, maybeParseDate } from 'utils/date-util'

export default class Translation {
  id = Id.none
  key = ''
  workspaceId = ''
  locale = ''
  value = ''
  dateCreated: Date = DateZero()
  dateModified: Date = DateZero()

  constructor(json: TranslationDTO) {
    this.id = json.id
    this.key = json.key
    this.workspaceId = json.workspace_id
    this.locale = json.locale
    this.value = json.value
    this.dateCreated = maybeParseDate(json.date_created)!
    this.dateModified = maybeParseDate(json.date_modified)!
  }
}
